<template>
  <main>
    <hero :heading="entry.title" :subheading="entry.hero.subheading" :images="entry.heroImages" position="bottom" />
    <div class="c-section">
      <div class="o-wrapper o-wrapper--small">
        <div class="o-box-off u-h5 u-ff-alt u-hl-blue-royal u-700 u-italic">
          <p>All online donations go towards supporting the core initiatives of the Chatham Islands Taiko Trust and positively impact in the ongoing conservation efforts within the Chatham Islands.</p>
        </div>
      </div>
      <div class="o-wrapper">
        <hr class="u-hr-grey u-mt+- u-mb+-">
      </div>
      <div class="o-wrapper o-wrapper--small">
        <div class="c-section__header u-mb">
          <h2 class="c-section__heading u-h3 u-600">Monthly Donation</h2>
        </div>
        <div class="o-layout">
          <div class="o-layout__item u-1/2 u-1/3@tablet u-1/7@desktop u-mb">
            <a class="c-donation-option" href="https://buy.stripe.com/cN2cOz8W41hb9Fe5kk" target="_blank">$25</a>
          </div>
          <div class="o-layout__item u-1/2 u-1/3@tablet u-1/7@desktop u-mb">
            <a class="c-donation-option" href="https://buy.stripe.com/eVa4i3a08aRLaJi5kl" target="_blank">$50</a>
          </div>
          <div class="o-layout__item u-1/2 u-1/3@tablet u-1/7@desktop u-mb">
            <a class="c-donation-option" href="https://buy.stripe.com/eVa7uf7S0aRLaJi5km" target="_blank">$100</a>
          </div>
          <div class="o-layout__item u-1/2 u-1/3@tablet u-1/7@desktop u-mb">
            <a class="c-donation-option" href="https://buy.stripe.com/9AQeWH7S06BvcRq3cf" target="_blank">$500</a>
          </div>
          <div class="o-layout__item u-1/2 u-1/3@tablet u-1/7@desktop u-mb">
            <a class="c-donation-option" href="https://buy.stripe.com/9AQ29V1tCcZT7x6dQU" target="_blank">$1000</a>
          </div>
          <div class="o-layout__item u-1/2 u-1/3@tablet u-1/7@desktop u-mb">
            <a class="c-donation-option" href="https://buy.stripe.com/9AQ29V0py0d7cRqaEJ" target="_blank">$500</a>
          </div>
        </div>
        <div class="c-section__header u-mb">
          <h2 class="c-section__heading u-h3 u-600">One-off Donation</h2>
        </div>
        <div class="o-layout">
          <div class="o-layout__item u-1/2 u-1/3@tablet u-1/7@desktop u-mb">
            <a class="c-donation-option" href="https://buy.stripe.com/28obKv1tC4tnaJieV0" target="_blank">$25</a>
          </div>
            <div class="o-layout__item u-1/2 u-1/3@tablet u-1/7@desktop u-mb">
              <a class="c-donation-option" href="https://buy.stripe.com/aEU3dZgow0d7g3CcMT" target="_blank">$50</a>
            </div>
            <div class="o-layout__item u-1/2 u-1/3@tablet u-1/7@desktop u-mb">
              <a class="c-donation-option" href="https://buy.stripe.com/aEU15RegobVP5oY28g" target="_blank">$100</a>
            </div>
            <div class="o-layout__item u-1/2 u-1/3@tablet u-1/7@desktop u-mb">
              <a class="c-donation-option" href="https://buy.stripe.com/3csaGrc8g3pj4kU4gp" target="_blank">$500</a>
            </div>
            <div class="o-layout__item u-1/2 u-1/3@tablet u-1/7@desktop u-mb">
              <a class="c-donation-option" href="https://buy.stripe.com/8wMbKvegof81g3C9AK" target="_blank">$1000</a>
            </div>
            <div class="o-layout__item u-1/2 u-1/3@tablet u-1/7@desktop u-mb">
              <a class="c-donation-option" href="https://buy.stripe.com/fZe29Vego9NH7x6cMX" target="_blank">$5000</a>
            </div>
        </div>
      </div>
      <div class="o-wrapper">
        <hr class="u-hr-grey u-mt+- u-mb+-">
      </div>
      <div class="o-wrapper o-wrapper--small">
        <p class="u-hl-grey-1">Send your donation by mail:</p>
        <div class="o-box-off u-3/4@desktop u-300">
          <p>Mail personal check made out to Chatham Island Taiko Trust to the following address:</p>
          <p>The Chatham Islands Taiko Trust <br>PO Box 2 <br>Chatham Islands 8942 <br>New Zealand</p>
          <p>Chatham Islands Taiko Trust is a charitable entity CC 25662.</p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from 'axios'
import Hero from '@/components/Hero.vue'

export default {
  name: 'Donate',
  metaInfo () {
    return {
      title: this.title
    }
  },
  components: {
    Hero: Hero
  },
  data () {
    return {
      title: '',
      entry: null
    }
  },
  mounted () {
    this.getEntry()
  },
  methods: {
    getEntry () {
      axios
        .get('api/donate.json')
        .then(response => {
          this.entry = response.data
          this.title = this.entry.title
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Donate.vue